import { CheckoutSession, Loan } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { buildFinancingLiveSummaryData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/maps/editFinancingDefaults.map';
import { FinancingLiveSummaryData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/FinancingLiveSummaryData';

interface UseEditFinancingDefaultsParams {
  checkoutSession: CheckoutSession;
  loan: Loan | undefined;
}

interface UseEditBorrowerAndFinancingDefaultsResult {
  financingSummary: FinancingLiveSummaryData;
}

export const useEditFinancingDefaults = ({
  checkoutSession,
  loan,
}: UseEditFinancingDefaultsParams): UseEditBorrowerAndFinancingDefaultsResult => {
  const financingSummary = useMemo(
    () =>
      buildFinancingLiveSummaryData({
        checkoutSession,
        loan,
      }),
    [checkoutSession, loan],
  );

  return {
    financingSummary,
  };
};
